<template>
  <div>
    <!--Main Div Enclosure-->
    <body>
      <!-- ======= Header ======= -->
      <header id="header" class="header fixed-top d-flex align-items-center">
        <div class="d-flex align-items-center justify-content-between">
          <a href="index.html" class="logo d-flex align-items-center">
            <img :src="getLogoPath" alt="" />
            <span class="d-none d-lg-block">{{ getAppName }}</span>
          </a>
        </div>
        <!-- End Logo -->

        <div>
          <form class="search-form d-flex align-items-center">
            <SwitchSchool
              :userId="getCurrentUser.id"
              @school-switched="getAndSetDataForSelectedSchool"
            ></SwitchSchool>
          </form>
        </div>

        <div class="row">
          <form class="search-form d-flex align-items-center">
            <v-list-item three-line>
              <v-autocomplete
                prepend-inner-icon="search"
                v-model="selectedStudentSid"
                :items="students"
                solo-inverted
                flat
                hide-details
                label="Search Student"
                @change="getStudentProfile()"
              ></v-autocomplete>
            </v-list-item>
          </form>
        </div>
        <!-- End Search Bar -->

        <nav class="header-nav ms-auto">
          <ul class="d-flex align-items-center">
            <li class="nav-item dropdown" v-if="!isMobile">
              <a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                <i class="bi bi-bell"></i>
                <span class="badge bg-primary badge-number">{{
                  notifications.length
                }}</span> </a
              ><!-- End Notification Icon -->

              <ul
                class="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications"
              >
                <li class="dropdown-header">
                  You have {{ notifications.length }} new notifications
                  <a href="#"
                    ><span class="badge rounded-pill bg-primary p-2 ms-2"
                      >View all</span
                    ></a
                  >
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <div v-for="(notification, n) in notifications" :key="n">
                  <li class="notification-item">
                    <i class="bi bi-exclamation-circle text-warning"></i>
                    <div>
                      <h4>Lorem Ipsum</h4>
                      <p>Quae dolorem earum veritatis oditseno</p>
                      <p>30 min. ago</p>
                    </div>
                  </li>

                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                </div>

                <!-- 
                <li class="notification-item">
                  <i class="bi bi-x-circle text-danger"></i>
                  <div>
                    <h4>Atque rerum nesciunt</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>1 hr. ago</p>
                  </div>
                </li>

                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li class="notification-item">
                  <i class="bi bi-check-circle text-success"></i>
                  <div>
                    <h4>Sit rerum fuga</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>2 hrs. ago</p>
                  </div>
                </li>

                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li class="notification-item">
                  <i class="bi bi-info-circle text-primary"></i>
                  <div>
                    <h4>Dicta reprehenderit</h4>
                    <p>Quae dolorem earum veritatis oditseno</p>
                    <p>4 hrs. ago</p>
                  </div>
                </li>

                <li>
                  <hr class="dropdown-divider" />
                </li> -->
                <li class="dropdown-footer">
                  <a href="#">Show all notifications</a>
                </li>
              </ul>
              <!-- End Notification Dropdown Items -->
            </li>
            <!-- End Notification Nav -->

            <li class="nav-item dropdown" v-if="!isMobile">
              <a class="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                <i class="bi bi-chat-left-text"></i>
                <span class="badge bg-success badge-number">{{
                  messages.length
                }}</span> </a
              ><!-- End Messages Icon -->

              <ul
                class="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages"
              >
                <li class="dropdown-header">
                  You have {{ messages.length }} new messages
                  <a href="#"
                    ><span class="badge rounded-pill bg-primary p-2 ms-2"
                      >View all</span
                    ></a
                  >
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <div v-for="(message, m) in messages" :key="m + 10000">
                  <li class="message-item">
                    <a href="#">
                      <img
                        src="niceAdmin/assets/img/messages-1.jpg"
                        alt=""
                        class="rounded-circle"
                      />
                      <div>
                        <h4>Maria Hudson</h4>
                        <p>
                          Velit asperiores et ducimus soluta repudiandae labore
                          officia est ut...
                        </p>
                        <p>4 hrs. ago</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <hr class="dropdown-divider" />
                  </li>
                </div>
                <!-- 
                <li class="message-item">
                  <a href="#">
                    <img
                      src="assets/img/messages-2.jpg"
                      alt=""
                      class="rounded-circle"
                    />
                    <div>
                      <h4>Anna Nelson</h4>
                      <p>
                        Velit asperiores et ducimus soluta repudiandae labore
                        officia est ut...
                      </p>
                      <p>6 hrs. ago</p>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li class="message-item">
                  <a href="#">
                    <img
                      src="assets/img/messages-3.jpg"
                      alt=""
                      class="rounded-circle"
                    />
                    <div>
                      <h4>David Muldon</h4>
                      <p>
                        Velit asperiores et ducimus soluta repudiandae labore
                        officia est ut...
                      </p>
                      <p>8 hrs. ago</p>
                    </div>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li> -->

                <li class="dropdown-footer">
                  <a href="#">Show all messages</a>
                </li>
              </ul>
              <!-- End Messages Dropdown Items -->
            </li>
            <!-- End Messages Nav -->

            <li class="nav-item dropdown pe-3">
              <a
                class="nav-link nav-profile d-flex align-items-center pe-0"
                href="#"
                data-bs-toggle="dropdown"
              >
                <!-- <img
                  src="images/profile-avatar.jpg"
                  alt="Profile"
                  class="rounded-circle"
                /> -->
                <v-app-bar-nav-icon
                  :color="adminPageItemsColor"
                ></v-app-bar-nav-icon>
                <span class="d-none d-md-block dropdown-toggle ps-2">{{
                  getCurrentUser.name
                }}</span> </a
              ><!-- End Profile Iamge Icon -->

              <ul
                class="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile"
              >
                <li class="dropdown-header">
                  <h6>{{ getCurrentUser.name }}</h6>
                  <span>{{ getCurrentUser.role }}</span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/')"
                  >
                    <i class="bi bi-layout-text-window-reverse"></i>
                    <span>FrontPage</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <!-- <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/school-galleries')"
                  >
                    <i class="bi bi-gem"></i>
                    <span>School Gallery</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li> -->

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/manage-employees')"
                  >
                    <i class="bi bi-people"></i>
                    <span>Manage Staff</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <!-- <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/events-calendar')"
                  >
                    <i class="bi bi-calendar"></i>
                    <span>Event Calendar</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li> -->

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/website-dashboard')"
                  >
                    <i class="bi bi-database"></i>
                    <span>Manage Site</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/salaries-and-payslips')"
                  >
                    <i class="bi bi-journal-text"></i>
                    <span>Manage Payroll</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/manage-users')"
                  >
                    <i class="bi bi-people"></i>
                    <span>Manage Users</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="routeTo('/settings')"
                  >
                    <i class="bi bi-gear"></i>
                    <span>School Profile</span>
                  </span>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="https://baronitsolutions.co.za"
                  >
                    <i class="bi bi-question-circle"></i>
                    <span>Need Help?</span>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider" />
                </li>

                <li>
                  <span
                    class="dropdown-item d-flex align-items-center"
                    @click="signOut()"
                  >
                    <i class="bi bi-box-arrow-right"></i>
                    <span>Sign Out</span>
                  </span>
                </li>
              </ul>
              <!-- End Profile Dropdown Items -->
            </li>
            <!-- End Profile Nav -->
          </ul>
        </nav>
        <!-- End Icons Navigation -->
      </header>
      <!-- End Header -->

      <!-- ======= Sidebar ======= -->
      <!-- <aside id="sidebar" class="sidebar">
        <ul class="sidebar-nav" id="sidebar-nav">
          <li class="nav-item">
            <a class="nav-link " href="index.html">
              <i class="bi bi-grid"></i>
              <span>FrontPage</span>
            </a>
          </li>

          <li class="nav-item">
            <span
              class="nav-link collapsed"
              data-bs-target="#icons-nav"
              data-bs-toggle="collapse"
              @click="routeTo('/school-galleries')"
            >
              <i class="bi bi-gem"></i><span>School Gallery</span>
            </span>
          </li>

          <li class="nav-item">
            <span
              class="nav-link collapsed"
              @click="routeTo('/manage-employees')"
            >
              <i class="bi bi-people"></i>
              <span>Manage Staff</span>
            </span>
          </li>

          <li class="nav-item">
            <span
              class="nav-link collapsed"
              @click="routeTo('/events-calendar')"
            >
              <i class="bi bi-calendar"></i>
              <span>Calendar</span>
            </span>
          </li>

          <li class="nav-item">
            <span
              class="nav-link collapsed"
              @click="routeTo('/website-dashboard')"
            >
              <i class="bi bi-database"></i>
              <span>Manage Site</span>
            </span>
          </li>

          <li class="nav-item">
            <span
              class="nav-link collapsed"
              @click="routeTo('/salaries-and-payslips')"
            >
              <i class="bi bi-card-list"></i>
              <span>Manage Payroll</span>
            </span>
          </li>

          <li class="nav-item">
            <span class="nav-link collapsed" @click="signOut()">
              <i class="bi bi-box-arrow-in-right"></i>
              <span>Sign Out</span>
            </span>
          </li>
        </ul>
      </aside> -->
      <!-- End Sidebar-->
      <div v-if="overlay">
        <v-row align="center" justify="center">
          <Loader></Loader>
          <v-card height="100%" width="100%">
            <v-row justify="center">
              <v-overlay :value="overlay">
                <div v-if="unauthorized">
                  <v-alert type="error">
                    Unauthorized Access for this User to the Selected School.
                    <br />Please Contact the School Admin!
                  </v-alert>
                  <v-btn color="error" class="mb-4" @click="signOut()"
                    >Sign Out</v-btn
                  >
                </div>
                <div v-else>
                  <v-btn color="success" class="mb-4" @click="setUserEmis()"
                    >Continue to {{ getAppName }}</v-btn
                  >

                  <v-row>
                    <div v-if="unauthorized" class="my-6 mx-auto">OR</div>
                  </v-row>
                  <SwitchSchool :userId="getCurrentUser.id"></SwitchSchool>
                </div>
              </v-overlay>
            </v-row>
          </v-card>
        </v-row>
      </div>
      <main class="ml-4" v-else>
        <div class="pagetitle">
          <h1>Dashboard</h1>
          <nav>
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="index.html">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>
        </div>
        <!-- End Page Title -->

        <section class="section dashboard">
          <div class="row">
            <!-- Left side columns -->
            <div class="col-lg-8">
              <div class="row">
                <!-- Total Fees Expected -->
                <div class="col-xxl-4 col-md-4">
                  <div class="card info-card sales-card">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown"
                        ><i class="bi bi-three-dots"></i
                      ></a>
                      <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('today')"
                            >Today</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('month')"
                            >This Month</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('year')"
                            >This Year</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">
                        {{
                          selectedStudentSid != null
                            ? financeInfo[0]["description"]
                            : "Total Fees Expected"
                        }}
                        <span> | {{ filter }}</span>
                      </h5>

                      <div class="d-flex align-items-center">
                        <div
                          class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <i class="bi bi-cart"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="card-title">
                            {{ getCurrency
                            }}{{
                              selectedStudentSid != null
                                ? financeInfo[0]["amount"]
                                : formatMoney(financeTotal.total_fees_expected)
                            }}
                          </h5>
                          <span class="text-success small pt-1 fw-bold"></span>
                          <span class="text-muted small pt-2 ps-1"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Total Fees Expected -->

                <!-- Total Fees Paid -->
                <div class="col-xxl-4 col-md-4">
                  <div class="card info-card revenue-card">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown"
                        ><i class="bi bi-three-dots"></i
                      ></a>
                      <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('today')"
                            >Today</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('month')"
                            >This Month</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('year')"
                            >This Year</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">
                        {{
                          selectedStudentSid != null
                            ? financeInfo[1]["description"]
                            : "Total Fees Paid"
                        }}<span> | {{ filter }}</span>
                      </h5>

                      <div class="d-flex align-items-center">
                        <div
                          class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <i class="bi bi-receipt-cutoff"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="card-title">
                            {{ getCurrency
                            }}{{
                              selectedStudentSid != null
                                ? financeInfo[1]["amount"]
                                : formatMoney(financeTotal.total_fees_paid)
                            }}
                          </h5>

                          <span class="text-success small pt-1 fw-bold"></span>
                          <span class="text-muted small pt-2 ps-1"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Total Fees Paid -->

                <!-- Total Fees Outstanding -->
                <div class="col-xxl-4 col-md-4">
                  <div class="card info-card customers-card">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown"
                        ><i class="bi bi-three-dots"></i
                      ></a>
                      <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('today')"
                            >Today</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('month')"
                            >This Month</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('year')"
                            >This Year</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">
                        {{
                          selectedStudentSid != null
                            ? financeInfo[2]["description"]
                            : "Total Fees Outstanding"
                        }}
                        <span> | {{ filter }}</span>
                      </h5>

                      <div class="d-flex align-items-center">
                        <div
                          class="card-icon rounded-circle d-flex align-items-center justify-content-center"
                        >
                          <i class="bi bi-people"></i>
                        </div>
                        <div class="ps-3">
                          <h5 class="card-title">
                            {{ getCurrency
                            }}{{
                              selectedStudentSid != null
                                ? financeInfo[2]["amount"]
                                : formatMoney(
                                    financeTotal.total_fees_outstanding
                                  )
                            }}
                          </h5>
                          <span class="text-danger small pt-1 fw-bold"></span>
                          <span class="text-muted small pt-2 ps-1"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- End Total Fees Outstanding -->

                <!-- Reports -->
                <div class="col-12">
                  <div class="card">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown"
                        ><i class="bi bi-three-dots"></i
                      ></a>
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">Useful Shortcuts <span></span></h5>
                      <v-row class="pb-n10">
                        <v-col :cols="isMobile ? 12 : 3"
                          ><v-btn
                            depressed
                            block
                            x-large
                            color="primary"
                            @click="openAddStudent"
                          >
                            Capture New Student
                          </v-btn></v-col
                        >
                        <v-col :cols="isMobile ? 12 : 3"
                          ><v-btn
                            depressed
                            block
                            x-large
                            color="error"
                            @click="openAddFeeID"
                          >
                            Create New Fee ID
                          </v-btn></v-col
                        >
                        <v-col :cols="isMobile ? 12 : 3"
                          ><v-btn
                            depressed
                            block
                            x-large
                            color="teal"
                            dark
                            @click="openApplyFeeID"
                          >
                            Apply Fee ID & More
                          </v-btn></v-col
                        >
                        <v-col :cols="isMobile ? 12 : 3"
                          ><v-btn
                            depressed
                            block
                            x-large
                            color="warning"
                            @click="openAddOrEditAnyData"
                          >
                            Add Or Edit Any Data
                          </v-btn></v-col
                        >
                      </v-row>
                    </div>
                  </div>
                </div>
                <!-- End Reports -->

                <!-- Reports -->
                <div class="col-12">
                  <div class="card">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown"
                        ><i class="bi bi-three-dots"></i
                      ></a>
                      <!-- <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('today')"
                            >Today</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('month')"
                            >This Month</a
                          >
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href="#"
                            @click="setFilter('year')"
                            >This Year</a
                          >
                        </li>
                      </ul> -->
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">Switchboard <span></span></h5>

                      <!-- Line Chart -->
                      <div>
                        <Loader></Loader>
                        <DashboardTiles2024 :tiles="tiles"></DashboardTiles2024>
                      </div>

                      <!-- End Line Chart -->
                    </div>
                  </div>
                </div>
                <!-- End Reports -->

                <!-- Recent Sales -->
                <div class="col-12">
                  <div class="card recent-sales overflow-auto">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown">
                        <!-- <i class="bi bi-three-dots"></i
                      > -->
                      </a>
                      <!-- <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li><a class="dropdown-item" href="#">Today</a></li>
                        <li>
                          <a class="dropdown-item" href="#">This Month</a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="#">This Year</a>
                        </li>
                      </ul> -->
                    </div>

                    <div class="card-body">
                      <h5 class="card-title">
                        Payments
                        <!-- Payments <span>| Today</span> -->
                      </h5>

                      <ViewPayments
                        v-if="studentProfile"
                        :payments="studentPayments"
                        :studentProfileFinanceInfo="
                          studentProfile['finance_info']
                        "
                        :student="selectedStudent"
                        @payment-deleted="refreshDashboard"
                      ></ViewPayments>
                      <ViewPayments
                        v-else
                        :payments="studentPayments"
                        :studentProfileFinanceInfo="null"
                        :student="null"
                        @payment-deleted="refreshDashboard"
                      ></ViewPayments>
                    </div>
                  </div>
                </div>
                <!-- End Recent Sales -->

                <!-- Top Selling -->
                <div class="col-12">
                  <div class="card top-selling overflow-auto">
                    <div class="filter">
                      <a class="icon" href="#" data-bs-toggle="dropdown">
                        <!-- <i class="bi bi-three-dots"></i
                      > -->
                      </a>
                      <!-- <ul
                        class="dropdown-menu dropdown-menu-end dropdown-menu-arrow"
                      >
                        <li class="dropdown-header text-start">
                          <h6>Filter</h6>
                        </li>

                        <li><a class="dropdown-item" href="#">Today</a></li>
                        <li>
                          <a class="dropdown-item" href="#">This Month</a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="#">This Year</a>
                        </li>
                      </ul> -->
                    </div>

                    <div class="card-body pb-0">
                      <h5 class="card-title">
                        Future Billings
                        <!-- <span>| Today</span> -->
                      </h5>

                      <ViewFutureBillings
                        :billings="studentFutureBillings"
                      ></ViewFutureBillings>
                    </div>
                  </div>
                </div>
                <!-- End Top Selling -->
              </div>
            </div>
            <!-- End Left side columns -->

            <!-- Right side columns -->
            <div class="col-lg-4">
              <!-- Recent Activity -->
              <div class="card">
                <div class="filter">
                  <a class="icon" href="#" data-bs-toggle="dropdown"></a>
                </div>

                <div class="card-body">
                  <h5 class="card-title">
                    Send SMS
                  </h5>

                  <div class="activity">
                    <SendSMS
                      :predefine="predefine"
                      :groupTable="groupTable"
                      :recipientsIDs="selectedStudentsSids"
                      @refresh-needed="refreshAnalyticsData"
                      :selectedSentSMSItem="null"
                    ></SendSMS>
                  </div>
                </div>
              </div>
              <!-- End Recent Activity -->

              <!-- Budget Report -->
              <div class="card">
                <div class="filter">
                  <a class="icon" href="#" data-bs-toggle="dropdown"></a>
                </div>

                <div class="card-body pb-0">
                  <div
                    id="budgetChart"
                    style="min-height: 400px;"
                    class="rechart"
                  >
                    <RecordPayment
                      :sid="selectedStudentSid"
                      :students="students"
                      @payment-recorded="paymentRecorded"
                    ></RecordPayment>
                  </div>
                </div>
              </div>
              <!-- End Budget Report -->

              <!-- Website Traffic -->
              <div class="card">
                <div class="filter"></div>

                <div class="card-body pb-0">
                  <h5 class="card-title">View Statement <span></span></h5>

                  <v-alert
                    color="warning"
                    v-if="studentProfile && studentProfile.finance_info"
                  >
                    <vInputField
                      :readonly="!isManager"
                      :defaultValue="studentProfile.finance_info.op"
                      label="Update Opening Balance"
                      :prefix="getCurrency"
                      @input-updated="updateOpeningBalance"
                      class="ml-4 mr-4 mt-2"
                      color="white"
                    >
                    </vInputField>
                  </v-alert>

                  <div
                    id="trafficChart"
                    style="min-height: 400px;"
                    class="echart"
                  >
                    <ViewStatement
                      :selectedStudentSid="selectedStudentSid"
                    ></ViewStatement>
                  </div>
                </div>
              </div>

              <!-- Website Traffic -->
              <div class="card" v-if="studentProfile">
                <div class="filter"></div>

                <div class="card-body pb-0">
                  <h5 class="card-title">Applied Fee IDs <span></span></h5>

                  <div
                    id="trafficChart"
                    style="min-height: 400px;"
                    class="echart"
                  >
                    <v-card-title
                      :style="{
                        'background-color': getThemeColor,
                        color: 'white',
                      }"
                      class="headline lighten-2"
                      >All Applied Fee IDs</v-card-title
                    >
                    <v-data-table
                      :headers="[
                        { text: 'Fee ID', value: 'fid' },
                        { text: 'Year', value: 'year' },
                        { text: 'Total', value: 'total' },
                      ]"
                      :items="studentProfile.fee_ids"
                      :items-per-page="5"
                      class="elevation-1"
                    ></v-data-table>
                  </div>
                </div>
              </div>
              <!-- End Website Traffic -->

              <!-- Website Traffic -->
              <div class="card" v-if="selectedStudentSid">
                <div class="filter"></div>

                <div class="card-body pb-0">
                  <v-card-title
                    class="card-title"
                    :style="{
                      'background-color': getThemeColor,
                      color: 'white',
                    }"
                    >Manage Discounts <span></span
                  ></v-card-title>

                  <div
                    id="trafficChart"
                    style="min-height: 400px;"
                    class="echart"
                  >
                    <CreateTargetDiscount
                      :selectedStudentSid="selectedStudentSid"
                      @discount-created="getStudentDiscounts"
                    ></CreateTargetDiscount>
                    <ViewTargetDiscounts
                      :discounts="discounts"
                    ></ViewTargetDiscounts>
                  </div>
                </div>
              </div>
              <!-- End Website Traffic -->

              <!-- News & Updates Traffic -->
              <div class="card">
                <div class="filter">
                  <a class="icon" href="#" data-bs-toggle="dropdown"> </a>
                </div>

                <div class="card-body pb-0">
                  <h5 class="card-title">
                    Calendar
                    <!-- <span>| Today</span> -->
                  </h5>

                  <div class="news">
                    <FullCalendar :options="calendarOptions" />
                  </div>
                  <!-- End sidebar recent posts-->
                </div>
              </div>
              <!-- End News & Updates -->
            </div>
            <!-- End Right side columns -->
          </div>
        </section>
      </main>
      <!-- End #main -->

      <!-- ======= Footer ======= -->
      <footer id="footer" class="footer">
        <div class="copyright">
          &copy; Copyright
          <strong>
            <a href="https://baronitsolutions.co.za/"
              >Baron IT Solutions</a
            ></strong
          >. All Rights Reserved
        </div>
        <div class="credits">
          Designed by
          <span>Kenny [076 243 9441]</span>
        </div>
      </footer>
      <!-- End Footer -->

      <a
        href="#"
        class="back-to-top d-flex align-items-center justify-content-center"
        ><i class="bi bi-arrow-up-short"></i
      ></a>
    </body>
    <GlobalDialogSlot
      :title="dialogTitle"
      :dialog="dialog"
      @close-dialog="closeDialog"
      :maxWidth="maxWidth"
    >
      <div v-if="dialogContext == 'add-student'">
        <AddStudentManually
          @student-added="getAllStudents()"
        ></AddStudentManually>
      </div>
      <div v-else-if="dialogContext == 'add-fee-id'">
        <SchoolFeesStructures></SchoolFeesStructures>
      </div>
      <div v-else-if="dialogContext == 'apply-fee-id'">
        <ManageStudents></ManageStudents>
      </div>
      <div v-else-if="dialogContext == 'add-edit-any-data'">
        <TablesDashboard></TablesDashboard>
      </div>
    </GlobalDialogSlot>
  </div>
  <!--End of Main Div Enclosure-->
</template>

<script>
import axios from "@/plugins/axios";
import helpersJs from "@/plugins/helpers";
import studentsJs from "@/plugins/students";
import financeJs from "@/plugins/finance";
import usersJs from "@/plugins/users";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import RecordPayment from "@/components/SchoolAdmin/RecordPayment.vue";
import DashboardTiles2024 from "@/components/myLibrary/DashboardTiles2024.vue";
import SendSMS from "@/modules/BulkSMS/SendSMS.vue";
import ViewStatement from "@/modules/TargetProfile/ViewStatement.vue";
import CreateTargetDiscount from "@/modules/TargetProfile/CreateTargetDiscount.vue";
import ViewTargetDiscounts from "@/modules/TargetProfile/ViewTargetDiscounts.vue";
import SwitchSchool from "@/components/myLibrary/SwitchSchool.vue";
import Loader from "@/components/Loader.vue";
import ViewFutureBillings from "@/modules/TargetProfile/ViewFutureBillings.vue";
import ViewPayments from "@/modules/TargetProfile/ViewPayments.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import AddStudentManually from "@/components/ManageStudents/AddStudentManually.vue";
import ManageStudents from "@/components/ManageStudents/ManageStudents.vue";
import TablesDashboard from "@/modules/CrudDatabases/TablesDashboard.vue";
import SchoolFeesStructures from "@/components/SchoolFees/SchoolFeesStructures.vue";
import vInputField from "@/components/Legos/vInputField.vue";

export default {
  components: {
    DashboardTiles2024,
    vInputField,
    TablesDashboard,
    RecordPayment,
    SendSMS,
    FullCalendar,
    ViewStatement,
    SwitchSchool,
    Loader,
    CreateTargetDiscount,
    ViewTargetDiscounts,
    ViewFutureBillings,
    ViewPayments,
    GlobalDialogSlot,
    AddStudentManually,
    ManageStudents,
    SchoolFeesStructures,
  },
  watch: {
    async selectedStudentSid(newVal) {
      if (newVal != null) {
        await this.getStudentProfile();
      }
    },
    async getUserSchool() {
      await this.getAndSetDataForSelectedSchool();
    },
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    adminPageItemsColor() {
      return "#012970";
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
    getLogoPath() {
      return this.$store.getters.getLogoPath;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
  },
  async mounted() {
    this.$store.commit("setIsMobile", this.$vuetify.breakpoint.isMobile);
    this.$store.commit("setLoader", true);
    const user = await usersJs.getCurrentUser();
    // this.$store.commit("setCurrentUser", user);
    this.$store.commit("setLoader", false);

    if (user.emis == this.getUserSchool.emis) {
      this.overlay = false;
      this.$store.dispatch("setUserStudents", {
        userId: user.id,
        token: this.getAccessToken,
      });
    } else {
      this.overlay = true;
    }

    await this.getAllStudents();
    await this.getAndSetDashboardIncomesData(this.filter);
  },
  updated() {
    const isMobile = this.$vuetify.breakpoint.mobile;
    this.$store.commit("setIsMobile", isMobile);
  },
  data: () => ({
    maxWidth: "550",
    dialog: false,
    dialogContext: null,
    dialogTitle: null,
    studentProfile: null,
    discounts: [],
    overlay: false,
    unauthorized: false,
    selectedStudentsSids: [],
    predefine: false,
    groupTable: null,
    profilePic: null,
    filter: "year",
    financeTotal: {
      total_fees_expected: 0,
      total_fees_outstanding: 0,
      total_fees_paid: 0,
    },
    notifications: [],
    students: [],
    selectedStudentSid: null,
    selectedStudent: null,
    studentNotFound: false,
    messages: [],
    financeInfo: [
      { description: "Previous Months", amount: 0 },
      { description: "Due Now", amount: 0 },
      { description: "Total Due", amount: 0 },
    ],
    studentFinance: null,
    studentPayments: [],
    studentFutureBillings: [],
    studentFeeIDs: [],
    calendarOptions: {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      events: [],
      selectable: true,
      buttonText: { today: "Today" },
      select: null,
      editable: true,
      eventClick: null,
      eventResize: null,
      eventDrop: null,
    },
    tiles: [
      {
        label: "Edit Any Data",
        dClass: "btn-big blue",
        iClass: "fa fa-pencil fa-4x",
        sClass: "label bottom",
        route: "manage-datatables",
        alevel: 7,
        industry: "General",
      },
      {
        icon: "mdi-account-details",
        title: "Student Profile",
        description: "",
        color: "teal",
        route: "student-profile",
        buttonText: "Enter",
        alevel: 5,
        param: "",
        industry: "General",
      },
      {
        id: 6,
        icon: "mdi-account-group",
        title: "Manage Students",
        description: "",
        route: "manage-students",
        param: "",
        alevel: 7,
        buttonText: "Enter",
        industry: "General",
      },

      {
        id: 6,
        icon: "mdi-cash-multiple",
        title: "Bulk Payments Capture",
        description: "",
        route: "bulk-payments-capturing",
        param: "",
        alevel: 7,
        buttonText: "Enter",
        industry: "General",
      },

      {
        label: "Bulk SMS",
        dClass: "btn-small green-bright",
        iClass: "fa fa-comment-o fa-4x",
        sClass: "label bottom",
        route: "bulk-sms-dashboard",
        alevel: 5,
        industry: "General",
      },

      {
        label: "School Admin",
        dClass: "btn-big purple",
        iClass: "fa fa-vcard fa-4x",
        sClass: "label bottom",
        route: "school-admin-switchboard",
        alevel: 5,
        industry: "General",
      },
      {
        label: "Fees & Arears",
        dClass: "btn-small gray",
        iClass: "fa fa-money fa-4x",
        sClass: "label bottom",
        route: "student-finance-dashboard",
        alevel: 7,
        industry: "General",
      },

      // {
      //   label: "Financial Reports",
      //   dClass: "btn-small blue",
      //   iClass: "fa fa-dollar fa-4x",
      //   sClass: "label bottom",
      //   route: "finance-switchboard",
      //   alevel: 9,
      //   industry: "General",
      // },
      {
        icon: "mdi-office",
        label: "Excel Uploads",
        route: "sasams-uploads",
        param: "",
        alevel: 7,

        industry: "General",
      },

      {
        id: 6,
        icon: "mdi-account-group",
        title: "Manage Users",
        description: "",
        route: "manage-users",
        param: "",
        alevel: 7,
        buttonText: "Enter",
        industry: "General",
      },
    ],
  }),
  methods: {
    async refreshDashboard() {
      if (this.selectedStudentSid != null) {
        await this.getStudentProfile();
      } else {
        await this.getAndSetDataForSelectedSchool();
      }
    },
    async setUserEmis() {
      const response = await usersJs.setUserEmis(this.getUserSchool.emis);
      if (response) {
        this.overlay = false;
      } else {
        this.overlay = true;
        this.unauthorized = true;
      }
    },
    getStudentDiscounts(discounts) {
      this.discounts = discounts;
    },
    async getAndSetDataForSelectedSchool() {
      this.$store.commit("setLoader", true);
      this.selectedStudentSid = null;
      await this.getAllStudents(true);
      await this.getAndSetDashboardIncomesData(this.filter);
      this.$store.commit("setLoader", false);
    },
    formatMoney(amount) {
      return helpersJs.formatMoney(amount);
    },
    async paymentRecorded(payments) {
      this.studentPayments = payments;
      await this.getStudentProfile();
    },
    refreshAnalyticsData() {
      this.$toast.success("SMS sent successfully!", { duration: 3000 });
    },
    async getAndSetDashboardIncomesData(filter) {
      this.$store.commit("setLoader", true);
      if (this.isAdmin) {
        const data = await financeJs.getDashboardIncomesData(
          filter,
          this.getUserSchool.emis
        );

        this.financeTotal = data;
        this.studentFutureBillings = data.billings;
        this.studentPayments = data.payments;
      }
      this.$store.commit("setLoader", false);
    },
    async getAllStudents(force = false) {
      this.$store.commit("setLoader", true);
      if (this.isStaff) {
        this.students = [];
        const studentsArr = await studentsJs.getStudents(force);
        studentsArr.forEach((student) => {
          this.students.push({
            text:
              student.lname + " " + student.fname + " [ " + student.sid + " ]",
            value: student.sid,
          });
        });
      }
      this.$store.commit("setLoader", false);
    },
    async getStudentProfile() {
      this.filter = "year";
      this.$store.commit("setLoader", true);
      this.selectedStudentsSids = [this.selectedStudentSid];
      const studentProfile = await studentsJs.getStudentProfile(
        this.selectedStudentSid
      );

      if (studentProfile == "not found") {
        if (!this.isStaff) {
          this.studentNotFound = true;
        }
      } else {
        this.studentProfile = studentProfile;
        this.studentNotFound = false;
        this.discounts = studentProfile.discounts;

        this.selectedStudent = studentProfile.student;
        this.$store.commit("setCurrentStudent", studentProfile.student);
        this.$store.commit("setCurrentStudentProfile", studentProfile);

        this.studentFutureBillings =
          studentProfile.finance_info.future_billings;
        this.studentPayments = studentProfile.payments;

        this.financeInfo[0]["description"] =
          studentProfile.finance_info.comment.split(" ")[0] + " B/F";
        this.financeInfo[0]["amount"] = studentProfile.finance_info.op;
        this.financeInfo[1]["amount"] =
          studentProfile.finance_info.expected_paid_excluding_current_month;
        this.financeInfo[2]["amount"] =
          studentProfile.finance_info.balance_due_month;

        // this.financeInfo[3]["amount"] =
        //   studentProfile.finance_info.balance_due_year;

        const img =
          this.getApiUrl +
          "/images/students_profile_pics/" +
          this.getUserSchool.emis +
          "/" +
          this.studentProfile.student.sid +
          ".jpeg";

        this.profilePic = img;
      }
      this.$store.commit("setLoader", false);
    },
    async setFilter(filter) {
      this.$store.commit("setLoader", true);
      if (!this.selectedStudentSid && this.isAdmin) {
        this.filter = filter;
        await this.getAndSetDashboardIncomesData(filter);
        return helpersJs.capitalizeFirstCharacter(filter);
      }
      this.$store.commit("setLoader", false);
    },
    routeTo(path) {
      if (this.isAdmin) {
        this.$router.push({ path: path });
      }
    },
    async signOut() {
      this.$store.commit("setLoader", true);
      await helpersJs.signOut();
      this.$store.commit("setLoader", false);
    },
    updateOpeningBalance(finalVal) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/update-opening-balance",
          {
            sid: this.selectedStudentSid,
            finalVal,
          },
          this.getAccessToken
        )
        .then((response) => {
          if (response == "success") {
            this.$toast.success("Opening Balance Updated Successfully!");
            this.getStudentProfile();
          } else {
            this.$toast.error("Oops, Something Went Wrong!");
          }
          this.$store.commit("setLoader", false);
        });
    },
    openAddStudent() {
      this.dialog = true;
      this.dialogContext = "add-student";
      this.dialogTitle = "Capture New Student";
    },
    openAddFeeID() {
      this.dialog = true;
      this.dialogContext = "add-fee-id";
      this.maxWidth = "1600";
      this.dialogTitle = "Create New Fee ID";
    },
    openApplyFeeID() {
      this.dialog = true;
      this.maxWidth = "1600";
      this.dialogContext = "apply-fee-id";
      this.dialogTitle = "Apply Fee ID & More";
    },
    openAddOrEditAnyData() {
      this.dialog = true;
      this.dialogContext = "add-edit-any-data";
      this.maxWidth = "1600";
      this.dialogTitle = "Add Or Edit Any Data";
    },
    closeDialog() {
      this.dialog = false;
      this.dialogContext = null;
      this.dialogTitle = null;
    },
  },
};
</script>
